import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import { isEmpty, lowerCase, startCase, toLower, upperCase } from "lodash";
import {
  Crash,
  Cricket,
  Fishing,
  games,
  PlatforAWC,
  Slot,
  sportBook,
  Table,
  vendorListCasino,
  vendorListCrash,
  vendorListFishing,
  vendorListSlot,
  vendorListTable,
} from "../Utils/gameData";
import Layout from "./Layout";
import AuthContext from "../context/AuthContext";
import ThemeContext from "../context/ThemeContext";
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";
// import { updateGameImageUrls } from "../updateGameImageUrls";
const PAGE_SIZE = 20;

const CATEGORY_DATA = {
  casino: games,
  slot: Slot,
  table: Table,
  crash: Crash,
  fishing: Fishing,
  cricket: Cricket,
  sportbook: sportBook,
};

const CATEGORY_VENDORS = {
  casino: vendorListCasino,
  slot: vendorListSlot,
  table: vendorListTable,
  crash: vendorListCrash,
  fishing: vendorListFishing,
  cricket: [],
  sportbook: [],
};

function GameCard({ game, handel }) {
  const { t } = useTranslation();
  const badgeIcon =
    game.badge === "hot"
      ? "/static/svg/game-icon-hot-mobile.svg"
      : game.badge === "new"
        ? "/static/svg/game-icon-new-mobile.svg"
        : null;

  // const localGames = updateGameImageUrls(Crash,'/assets/crash');

  // console.log(localGames,'localGames')

  // normalize: lowercase + strip all whitespace
const normalize = (str = "") => str.toLowerCase().replace(/\s+/g, "");

// build a Map keyed by `platform_normalizedName` for O(1) lookups
function buildReferenceMap(reference) {
  const map = new Map();

  for (const platformKey in reference) {
    reference[platformKey].forEach((game) => {
      const lookupKey = `${platformKey}_${normalize(game.Name)}`;
      map.set(lookupKey, game);
    });
  }

  return map;
}

// merge Slot array with matching reference data
function mergeSlotWithReference(slotArray, reference) {
  const refMap = buildReferenceMap(reference);

  return slotArray.map((slot) => {
    const lookupKey = `${slot.key}_${normalize(slot.name)}`;
    const match = refMap.get(lookupKey);

    if (!match) return slot; // no match, return as-is

    return {
      ...slot,
      gameCode: match.casinoType,
      gameType: match.gameType,
      platFormCode: match.platFormCode,
    };
  });
}
function countUnmatched(slotArray, reference) {
  const refMap = buildReferenceMap(reference);
  let unmatchedCount = 0;
  const unmatchedItems = [];

  slotArray.forEach((slot) => {
    const lookupKey = `${slot.key}_${normalize(slot.name)}`;
    if (!refMap.has(lookupKey)) {
      unmatchedCount++;
      unmatchedItems.push(slot);
    }
  });

  return { unmatchedCount, unmatchedItems };
}
const updatedSlots = mergeSlotWithReference(games, PlatforAWC);
console.log(updatedSlots)
// const { unmatchedCount, unmatchedItems } = countUnmatched(Slot, PlatforAWC);
// console.log("Unmatched count:", unmatchedCount);
// console.log("Unmatched items:", unmatchedItems);
// console.log(updatedSlots);
  return (
    <span
      onClick={() => handel(game)}
      right=""
      className="v-badge v-badge--overlap theme--light"
    >
      <div className="slot-game-card">
        <div className="v-image v-responsive slot-game-image-box theme--light">
          <div
            className="v-responsive__sizer"
            style={{ paddingBottom: "66.6667%" }}
          />
          <div
            className={
              game.image
                ? "v-image__image v-image__image--cover"
                : "v-image__image v-image__image--preload v-image__image--cover"
            }
            style={
              game.image
                ? {
                    backgroundImage: `url("${game.image}")`,
                    backgroundPosition: "center center",
                  }
                : { backgroundPosition: "center center" }
            }
          />
          <div className="v-responsive__content" style={{ width: "450px" }} />
        </div>

        <div game-name={game.name} className="slot-game-button-container">
          <div className="slot-game-button-box">
            <button className="button-primary playBtn">{t("PlayNow")}</button>
          </div>
        </div>
      </div>

      <div className="slot-game-name-box">{game.name}</div>

      {badgeIcon && (
        <span className="v-badge__wrapper">
          <span
            aria-atomic="true"
            aria-label={t("Badge")}
            aria-live="polite"
            role="status"
            className="v-badge__badge light"
            style={{ inset: "auto auto calc(100% - 30px) calc(100% - 30px)" }}
          >
            <div className="v-image v-responsive badge-img theme--light">
              <div
                className="v-responsive__sizer"
                style={{ paddingBottom: "100%" }}
              />
              <div
                className="v-image__image v-image__image--cover"
                style={{
                  backgroundImage: `url("${badgeIcon}")`,
                  backgroundPosition: "center center",
                }}
              />
              <div
                className="v-responsive__content"
                style={{ width: "25px" }}
              />
            </div>
          </span>
        </span>
      )}
    </span>
  );
}

function buildPageList(current, total) {
  const pages = [];
  for (let p = 1; p <= total; p++) {
    const isEdge = p === 1 || p === total;
    const isNear = Math.abs(p - current) <= 1;
    if (isEdge || isNear) {
      pages.push(p);
    } else if (pages[pages.length - 1] !== "more") {
      pages.push("more");
    }
  }
  return pages;
}

export default function Casino() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const setLoginModalShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLoginModalShow;
  });
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.launchCasino;
  });
  const navigate = useNavigate();
  const [active, setActive] = useState("casino");
  const [input, setInput] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [page, setPage] = useState(1);

  // derive category + provider from query params instead of route params
  const typeParam = searchParams.get("type");
  const providerParam = searchParams.get("provider");

  useEffect(() => {
    setActive(!isEmpty(typeParam) ? lowerCase(typeParam) : "casino");
  }, [typeParam]);

  const vendors = CATEGORY_VENDORS[active] || [];

  // vendor list is category-specific; seed selection from ?provider= on category change
  useEffect(() => {
    if (!isEmpty(providerParam)) {
      const fromUrl = providerParam
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);
      setSelectedVendors(
        fromUrl?.map((res) => {
          return upperCase(res);
        }),
      );
    } else {
      setSelectedVendors([]);
    }
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps

  // local state only — no URL sync
  const toggleVendor = (name) => {
    setSelectedVendors((prev) =>
      prev.includes(name) ? prev.filter((v) => v !== name) : [...prev, name],
    );
  };

  const filteredGames = useMemo(() => {
    let result = CATEGORY_DATA[active] || [];
    if (!isEmpty(selectedVendors)) {
      result = result.filter((g) => selectedVendors.includes(g?.key));
    }
    if (!isEmpty(input)) {
      result = result.filter((g) => toLower(g?.name).includes(toLower(input)));
    }
    return result;
  }, [active, selectedVendors, input]);

  // reset to page 1 whenever the active filters change
  useEffect(() => {
    setPage(1);
  }, [active, selectedVendors, input]);

  const totalPages = Math.max(1, Math.ceil(filteredGames.length / PAGE_SIZE));
  const pageList = useMemo(
    () => buildPageList(page, totalPages),
    [page, totalPages],
  );

  const start = (page - 1) * PAGE_SIZE;
  const visibleGames = filteredGames.slice(start, start + PAGE_SIZE);

  const goTo = (p) => {
    if (p < 1 || p > totalPages) return;
    setPage(p);
  };

  const handel = (res) => {
    if (!isEmpty(user)) {
      if (res?.name == "Velki") {
        if (isEmpty(user)) {
          setLoginModalShow(true);
        } else {
          navigate("/sports-velki");
        }
      } else if (res?.name == "9Wicket") {
        if (isEmpty(user)) {
          setLoginModalShow(true);
        } else {
          if (isMobile) {
            navigate("/inplay-sky");
          } else {
            navigate("/sports-sky");
          }
        }
      } else {
        if (isEmpty(res?.platFormCode)) {
          toast.error(t("ComingSoon"));
        } else {
          launchCasino({
            platForm: res?.platFormCode,
            gameType: res?.gameType,
            casinoType: res?.casinoType || res?.gameCode,
    
          });
        }
      }
    } else {
      setLoginModalShow(true);
    }
  };
  return (
    <Layout>
      <div className="game-container">
        <div className="game-banner">
          <div className="v-image v-responsive align-end theme--light">
            <div
              className="v-responsive__sizer"
              style={{ "padding-bottom": "33.3333%" }}
            />
            <div
              className="v-image__image v-image__image--cover"
              style={{
                "background-image":
                  'url("/assets/images/ld.webp")',
                "background-position": "center center",
              }}
            />
            <div className="v-responsive__content">
              <div className="v-card__title font-weight-bold pa-0 white--text">
                <p className="mb-0 ml-3">
                  <span className="text-capitalize">{startCase(active)}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        {!["cricket", "sportbook"].includes(active) && (
          <>
            <div className="search-container">
              <div no-gutters className="search-wrapper">
                <div className="v-input search_game pl-0 v-input--hide-details v-input--dense theme--light v-text-field v-text-field--single-line v-text-field--solo v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-select v-autocomplete">
                  <div className="v-input__prepend-outer">
                    <div className="v-input__icon v-input__icon--prepend">
                      <i
                        aria-hidden="true"
                        className="v-icon notranslate material-icons theme--light"
                      >
                        search
                      </i>
                    </div>
                  </div>
                  <div className="v-input__control">
                    <div
                      role="combobox"
                      aria-haspopup="listbox"
                      aria-expanded="false"
                      aria-owns="list-2797"
                      className="v-input__slot"
                    >
                      <div className="v-select__slot">
                        <label
                          htmlFor="input-2797"
                          className="v-label theme--light"
                          style={{
                            left: "0px",
                            right: "auto",
                            position: "absolute",
                          }}
                        >
                          {t("SearchGames")}
                        </label>
                        <input
                          autoComplete="off"
                          id="input-2797"
                          type="text"
                          value={input}
                          onChange={(e) => setInput(e.target.value)}
                        />
                        <div className="v-input__append-inner">
                          <div />
                        </div>
                        <div className="v-input__append-inner">
                          <div className="v-input__icon v-input__icon--append">
                            <button
                              aria-hidden="true"
                              type="button"
                              tabIndex={-1}
                              className="v-icon notranslate v-icon--link mdi mdi-menu-down theme--light"
                            />
                          </div>
                        </div>
                        <input type="hidden" />
                      </div>
                      <div className="v-menu">{/**/}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="game-vendor-container">
              <div className="game-vendor-wrapper">
                <div className="game-list-container d-flex justify-start">
                  {vendors.map((v) => {
                    const checked =
                      isEmpty(selectedVendors) ||
                      selectedVendors.includes(v.key);
                    return (
                      <div
                        key={v.key}
                        className="vendor-list-item slot-product"
                      >
                        <div className="v-input v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light v-input--selection-controls v-input--checkbox primary--text">
                          <div className="v-input__control">
                            <div className="v-input__slot">
                              <div className="v-input--selection-controls__input">
                                <i
                                  aria-hidden="true"
                                  className={`v-icon notranslate ${
                                    checked
                                      ? "mdi mdi-checkbox-marked"
                                      : "mdi mdi-checkbox-blank-outline"
                                  } theme--light primary--text`}
                                />
                                <input
                                  aria-checked={checked}
                                  id={`input-vendor-${v.key}`}
                                  role="checkbox"
                                  type="checkbox"
                                  checked={checked}
                                  onChange={() => toggleVendor(v.key)}
                                />
                                <div className="v-input--selection-controls__ripple primary--text" />
                              </div>
                              <label
                                htmlFor={`input-vendor-${v.key}`}
                                className="v-label theme--light"
                                style={{
                                  left: "0px",
                                  right: "auto",
                                  position: "relative",
                                }}
                              >
                                {v.name}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>{" "}
          </>
        )}
        <div className="games-card-container py-4">
          <div className="mx-auto games-card-wrapper px-2">
            {visibleGames.map((game, i) => (
              <GameCard
                handel={handel}
                key={`${game.name}-${start + i}`}
                game={game}
              />
            ))}
          </div>
          <div className="text-center mb-6">
            <nav
              role="navigation"
              aria-label={t("PaginationNavigation")}
              className="game_pagination"
            >
              <ul className="v-pagination theme--light">
                <li>
                  <button
                    type="button"
                    aria-label={t("PreviousPage")}
                    disabled={page === 1}
                    onClick={() => goTo(page - 1)}
                    className={
                      page === 1
                        ? "v-pagination__navigation v-pagination__navigation--disabled"
                        : "v-pagination__navigation"
                    }
                  >
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      arrow_back_ios
                    </i>
                  </button>
                </li>

                {pageList.map((p, i) =>
                  p === "more" ? (
                    <li key={`more-${i}`}>
                      <span className="v-pagination__more">...</span>
                    </li>
                  ) : (
                    <li key={p}>
                      <button
                        type="button"
                        aria-current={p === page ? "true" : undefined}
                        aria-label={
                          p === page
                            ? t("CurrentPagePage", { page: p })
                            : t("GotoPage", { page: p })
                        }
                        onClick={() => goTo(p)}
                        className={
                          p === page
                            ? "v-pagination__item v-pagination__item--active primary"
                            : "v-pagination__item"
                        }
                      >
                        {p}
                      </button>
                    </li>
                  ),
                )}

                <li>
                  <button
                    type="button"
                    aria-label={t("NextPage")}
                    disabled={page === totalPages}
                    onClick={() => goTo(page + 1)}
                    className={
                      page === totalPages
                        ? "v-pagination__navigation v-pagination__navigation--disabled"
                        : "v-pagination__navigation"
                    }
                  >
                    <i
                      aria-hidden="true"
                      className="v-icon notranslate material-icons theme--light"
                    >
                      arrow_forward_ios
                    </i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </Layout>
  );
}
